const spinner = require('vue-strap').spinner;

export default {
  name: 'uploading',
  components: { spinner },
  props: [
    'uploaded',
    'total',
    'visible',
    'image',
  ],
  mounted() {

  },
  data() {
    return {
    };
  },
  methods: {

  },
  computed: {

  },
};



// WEBPACK FOOTER //
// ./src/components/uploading/uploading.component.js